import env from "../../utils/env";

let BusinessesService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb, errorCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("businesses/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "notes": { nullable: false, validation: { required: false } },
            "locationStatus": { defaultValue: 0 },
            "id": {},
          }
        }
      },
      error: errorCb,
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  const getBusinessDetails = (id, successCb, failureCb) => {
    HttpService.get(`businesses/${id}`, successCb, failureCb);
  }

  return {
    getDataSource,
    getBusinessDetails,
  };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`businesses/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if (type == "create") {
    delete data.id;
    console.log("Data::", data);

    return JSON.stringify(data);
  }

  if (type == "update") {

    console.log("Data::", data);

    return JSON.stringify(data);
  }
}

export default BusinessesService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/businesses.service.js
 **/